import React, {useEffect} from "react"
import connect from "./connect"
import {MessageBannerItem} from "../../models/messageBanner"
import {BannerWrapper} from "./component"
import MessageBannerCarousel from "../MessageBannerCarousel"

export type MessageBannerProps = {
    getMessageBannerData: () => void
    items: MessageBannerItem[]
    autoPlayTime?: number
    infinite: boolean
    pauseOnHover: boolean
}
export const MessageBanner = ({
    getMessageBannerData,
    items,
    autoPlayTime,
    infinite,
    pauseOnHover,
}: MessageBannerProps) => {
    useEffect(() => {
        // Setting the timeout to 0 to make sure bag/get and other network calls are initiated before fetching the message banner data
        setTimeout(() => {
            getMessageBannerData()
        }, 0)
    }, [])
    return items && items.length > 0 ? (
        <BannerWrapper data-testid="header-message-banner" className="header-message-banner">
            <MessageBannerCarousel
                items={items}
                autoplayTime={autoPlayTime || 4000}
                infinite={infinite}
                pauseOnHover={pauseOnHover}
            />
        </BannerWrapper>
    ) : null
}
export default connect(MessageBanner)
